module.exports = __webpack_public_path__ + "img/block-calendar.f8680b76.png";